import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconName } from '@fortawesome/free-solid-svg-icons';
import { TypeSectionTextFields } from '../../../models/contentful-content-types/section-text';
import { AssetFile } from 'contentful';
import { TileTextComponent } from '../tile-text/tile-text.component';

@Component({
    imports: [CommonModule, FontAwesomeModule, TileTextComponent],
    selector: 'jnguyen-section-text',
    templateUrl: './section-text.component.html',
})
export class SectionTextComponent {
  @Input() data: TypeSectionTextFields;
  documentToHtmlString = documentToHtmlString;

  getIcon(icon: IconName, iconClass: string): string[] {
    return [iconClass, icon];
  }

   getImageUrl(url: string | AssetFile) {
    if (typeof url === "string") {
      const cutUrl = url.replace(/\/\/images\.ctfassets\.net\//, "");
      return `${cutUrl}`;
    }
  }
}
